export const runtimeEnvironment = {
  BUILD_NUMBER: '127a1328-ed8d-4f85-8b14-30361f23e319',
  SENTRY_ENABLED: true,
};
